import { useEffect, useState } from "react";
import { PublicStore } from "../../../store/PublicStore";
import style from "./OurApps.module.scss";

export default function OurApps() {

  const [openState, setOpenState] = useState(false);
  const { globalData } = PublicStore();

  useEffect(() => {
    if (!openState) return;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setOpenState(false);
      }
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [openState]);


  return (
    <div className="position-relative">
      <div className="d-flex align-items-center">
        <button
          className={`bg-color-transparent border-width-0 px-10 ${style.AppToggle}`}
          onClick={e => { setOpenState(prev => !prev) }}
          aria-expanded={openState}
          aria-label="Open app switcher"
        >
          <ion-icon name="apps-outline" className="d-block"></ion-icon>
        </button>
      </div>


      <div className={`${style.AppListContainer} ${openState ? style.Active : ''}`}>
        {globalData?.nav_menu?.filter(app => app.short_name !== 'Lushai Analytics' && app.name !== 'Lushai Analytics').map(app => (
          <a key={app.id} href={app.url} target="_blank" rel="noreferrer" className="d-block" onClick={e => { setOpenState(false) }}>
            <ion-icon name={app.icon_name}></ion-icon>
            <h4>{app.short_name}</h4>
          </a>
        ))}
      </div>

      <div onClick={e => { setOpenState(false) }} className={`${style.BackDrop} ${openState ? style.Active : ''}`}></div>

    </div>
  )
}
